<template>
  <a-card :bordered="false">
    <a-row :gutter="[16,32]">
      <a-col :span="14" :offset="4" style='text-align: center;'>
        <h2>抽取进入评标基准价计算的投标报价</h2>
      </a-col>
    </a-row>
    <a-row :gutter="[16,32]">
      <a-form-model-item :label-col="{span: 4, offset: 2}" :wrapper-col="{span: 12}" label="进入计算投标人评标价：">
        <font color="red">（备注：若抽中方法一，系统会自动判断需要剔除的最高、最低报价）</font>
        <a-table bordered :data-source="dataSource" :columns="columns" :pagination="false" style='margin-top: 10px;margin-bottom: 10px;'>
          <template
            slot="randomBall"
            slot-scope="text, record, index"
          >
            <div>
              <a-input
                :ref="'input_'+index"
                style="margin: -5px 0;"
                :value="record.bidderBall"
                @blur="e => handleRandomBallChange(e.target.value, record)"
                @keyup.enter.native="e => handleRandomBallKeyup(e.target.value,record,index)"
              />
            </div>
          </template>
          <template slot="operation" slot-scope="text, record ,index">
            <a-popconfirm
              v-if="dataSource.length"
              title="确定删除行?"
              @confirm="() => onDelete(record,index)"
            >
              <a href="javascript:;" :disabled="isCheck">删除行</a>
            </a-popconfirm>
          </template>
          <template #title>
            <a-space>
              <a-button type='primary' @click='addRow'>新增一行</a-button>
              <a-button type='primary' @click='allAddRow'>全部入围</a-button>
            </a-space>
          </template>
        </a-table>
      </a-form-model-item>
    </a-row>
    <a-row :gutter="[16,32]">
      <a-col :span="16" :offset="4" style='text-align: center'>
        <a-button type="primary" style="margin-right: 10px" @click="prevStep">上一步</a-button>
        <a-button style="margin-right:10px;" :disabled="isCheck" type='primary' @click="saveDataSource">保存</a-button>
        <a-button type="primary" :disabled="!showSave" style="margin-right: 10px"  @click="nextStep">下一步</a-button>
      </a-col>
    </a-row>
  </a-card>
</template>

<script>
import { postAction,getAction } from '@api/manage'
import ARow from 'ant-design-vue/es/grid/Row'
export default {
  name: 'WaterTransportBenchmarkPriceComputeStep4',
  components: { ARow },
  data() {
    return {
      avgPrice: null,
      showSave:false,
      benchmarkPriceDown:null,
      benchmarkPrice:null,
      tentativeAmount:null,
      controlPrice:null,
      isCheck: true,
      dataSource: [],
      idList: [],
      columns: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function(t, r, index) {
            return parseInt(index) + 1
          }
        },
        {
          title: '球号',
          align: 'center',
          dataIndex: 'bidderBall',
          width: 200,
          scopedSlots: { customRender: 'randomBall' },
        },
        {
          title: '投标人名称',
          align: 'center',
          dataIndex: 'bidderName'
        },
        {
          title: '企业信用等级',
          align: 'center',
          dataIndex: 'enterpriseCreditGrade',
          customRender: function(t, r, index) {
           if(t==null)
           {
             return '/'
           }
           return t;
          }
        },
        {
          title: '投标报价金额（元）',
          align: 'center',
          dataIndex: 'bidPrice'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
        },
      ],
    }
  },
  props: ['sectionId','bidProjectId','workflowInstanceId'],
  created() {
    this.setButtonStatus();
    this.initDataSource();
  },
  methods: {
    setButtonStatus(){
      let that = this
      getAction('/ebid-ce/boOpenStatus/getBoOpenStatus', {
        sectionId: that.sectionId,
      }).then((res) => {
        if (res.success) {
          if(res.result.isKstandPriceFinish==1){
            that.isCheck = true;
          }else {
            that.isCheck = false;
          }
        }
      })
    },
    /**
     * 获取进入评标基准价计算的投标报价
     */
    initDataSource() {
      let that = this
      //1 查询后台企业数据
      getAction('/ebid-ce/waterTransportBenchmarkPriceCompute/getParticipateBenchmarkPrice/' + this.bidProjectId + "/" + this.sectionId, {}).then(res => {
        //如果数据已提交,直接显示数据
        if (res.result && res.result.length > 0) {
          that.dataSource = res.result;
          for (let i = 0; i < that.dataSource.length; i++) {
            that.idList.push(that.dataSource[i].id);
          }
        }
      });
    },
    //提交参与评标基准价计算的投标报价
    saveDataSource() {
      let that = this
      let paramList = []
      for (let i = 0; i < that.dataSource.length; i++) {
        paramList.push({
          id: that.dataSource[i].id
        })
      }
      let params ={};
      params.tmBidderList = paramList;
      params.bidProjectId = this.bidProjectId;
      params.sectionId = this.sectionId;

      postAction('/ebid-ce/waterTransportBenchmarkPriceCompute/saveParticipateBenchmarkPrice/' + this.workflowInstanceId + "/" + this.sectionId, params).then(res => {
        if (res.success) {
          that.$message.success('提交参与评标基准价计算的投标报价成功')
          //that.$emit('nextStep')
          that.showSave=true;
        } else {
          that.$message.warning(res.message)
        }
      });
    },
    //添加一行入围企业
    addRow(){
      this.dataSource.push({
        id: '',
        bidderBall: null,
        bidderName: '',
        enterpriseCreditGrade: '',
        bidPrice: null,
      })
    },
    allAddRow() {
      let that = this
      getAction('/ebid-ce/waterTransportBenchmarkPriceCompute/getAllTmBidderList/' + this.bidProjectId + '/' + this.sectionId).then(res => {
        if (res.success) {
          that.idList = [];
          that.dataSource = [];
          for (let i = 0; i < res.result.length; i++) {
            that.dataSource.push({
              id: res.result[i].id,
              bidderBall: res.result[i].bidderBall,
              bidderName: res.result[i].bidderName,
              enterpriseCreditGrade: res.result[i].enterpriseCreditGrade,
              bidPrice: res.result[i].bidPrice,
            })
            that.idList.push(res.result[i].id)
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },
    /**
     * 随机球号值改变
     */
    handleRandomBallChange(ballValue, record) {
      let that = this
      if (!ballValue || ballValue == '') {
        that.clearRecord(record, true);
        return
      }
      const reg = /^[+-]?(0|([1-9]\d*))(\.\d+)?$/g
      if(!reg.test(ballValue)){
        this.$message.error('球号只能是数字')
        that.clearRecord(record, true);
        return
      }
      if (ballValue == record.bidderBall) {
        //新旧值一致
        return
      }
      getAction('/ebid-ce/waterTransportBenchmarkPriceCompute/getAllTmBidderList/' + this.bidProjectId + '/' + this.sectionId + '/' + ballValue).then(res => {
        if (res.success) {
          if (res.result.length == 0) {
            that.$message.error('该球号不在可抽取的范围');
            //重置数据
            that.clearRecord(record,true);
            return
          }
          if (that.idList.indexOf(res.result[0].id) != -1) {
            that.$message.error('该企业已输入')
            //重置数据
            that.clearRecord(record,true);
            return
          }
          if(that.idList.indexOf(record.id) > -1) {
            that.idList.splice(that.idList.indexOf(record.id), 1);
          }
          record.id = res.result[0].id
          record.bidderBall = res.result[0].bidderBall
          record.bidderName = res.result[0].bidderName
          record.enterpriseCreditGrade = res.result[0].enterpriseCreditGrade
          record.bidPrice = res.result[0].bidPrice
          that.idList.push(res.result[0].id)
        } else {
          that.clearRecord(record, true);
          this.$message.error(res.message)
        }
      })
    },
    /**
     * inupt输入框回车事件
     */
    handleRandomBallKeyup(ballValue, record, index) {
      if (index >= this.dataSource.length - 1) {
        this.$refs['input_' + index].blur()
        return
      }
      const reg = /^[+-]?(0|([1-9]\d*))(\.\d+)?$/g
      if(!reg.test(ballValue)){
        record.bidderBall = null;
        this.clearRecord(record, true);
        this.$message.error('球号只能是数字')
        return
      }
      let newIndex = index + 1
      this.$refs['input_' + newIndex].focus()
    },
    clearRecord(record , type){
      if (type && this.idList.indexOf(record.id) > -1) {
        this.idList.splice(this.idList.indexOf(record.id), 1);
      }
      if(record && record.id){
        record.id = ''
        record.bidderName = null
        record.enterpriseCreditGrade = null
        record.bidderBall = null
        record.bidPrice = null
      }
    },
    onDelete(record , index) {
      this.dataSource.splice(index, 1);
      this.clearRecord(record, true);
    },
    handleEdit(record){
      alert(record.evaluationPrice);
    },
    prevStep () {
      this.$emit('prevStep')
    },
    nextStep () {
      this.$emit('nextStep')
    }
  }
}
</script>

<style scoped>

</style>